import AiProfilesList from "@/pages/admin/ai-profiles/index";
import AiProfileCreate from "@/pages/admin/ai-profiles/create";
import AiProfileEdit from "@/pages/admin/ai-profiles/edit";

export const aiProfilesRoutes = [
  {
    id: "aiProfilesList",
    path: "",
    index: true,
    element: <AiProfilesList />,
  },
  {
    id: "aiProfileCreate",
    path: "create",
    element: <AiProfileCreate />,
  },
  {
    id: "aiProfileEdit",
    path: "edit/:id",
    element: <AiProfileEdit />,
  },
];
